import {
  DEFAULT_EMPTY_VALUE,
  ROLE_VIEW_MAP,
  PRODUCT_NAME,
  PAGE_NAME,
} from '../constants';
import { MULTI_ROLE_SEPARATOR, ROLES, USER_STATUS } from '../constants/roles';

import {
  convertIdToValue,
  getItemOrDefaultToValue,
  getValueFromConstantObject,
} from '../details';
import services_suite from 'static/services.json';
import isEmpty from 'lodash/isEmpty';

export const getDisplayRoles = list => {
  const item = getItemOrDefaultToValue(list, 'roles', []);

  const roles = item.map(role => {
    return convertIdToValue({
      list: role,
      constant: ROLES,
      defaultValue: DEFAULT_EMPTY_VALUE,
    });
  });

  return roles.join(MULTI_ROLE_SEPARATOR);
};

export const getRoleId = (list, defaultValue) => {
  const [value] = getItemOrDefaultToValue(list, 'roles', []);
  return value
    ? getValueFromConstantObject({ constant: ROLES, value, key: 'id' })
    : defaultValue;
};

export const getUserStatus = list => {
  return convertIdToValue({
    list,
    key: 'status',
    constant: USER_STATUS,
    defaultValue: USER_STATUS.NOT_LOGGED_IN.name,
  });
};

export const getUserStatusId = list => {
  return getValueFromConstantObject({
    constant: USER_STATUS,
    value: list.status,
    key: 'id',
  });
};

export const checkIfUserIsSimpleUser = role => {
  if (!role) {
    return false;
  }
  if (typeof role === 'string') {
    return (
      role === ROLES.CLEANER.id ||
      role === ROLES.GUARD.id ||
      role === ROLES.MAINTAINER.id
    );
  }
  // it will be an array
  return role.some(
    r =>
      r === ROLES.CLEANER.id ||
      r === ROLES.GUARD.id ||
      r === ROLES.MAINTAINER.id,
  );
};

export const checkIfUserIsAllowedView = (currentPage, userRoles) => {
  if (userRoles.length < 1) return false;
  // check if the user role exists in the map
  const roleExists = userRoles.some(role => ROLE_VIEW_MAP[role]);
  if (!roleExists) return false;
  // if yes, find what view is it allowed
  const allowedRole = userRoles.filter(role => ROLE_VIEW_MAP[role]);
  const allowedViews = ROLE_VIEW_MAP[allowedRole[0]];
  // if the current page that is asked for exists in the views, then return yes, otherwise false
  return allowedViews.includes(currentPage);
};

export const checkIfTheCompanyHasService = (currentPage, companyDetails) => {
  // make a map of view and product suites
  switch (currentPage) {
    case PAGE_NAME.SECURITY_OPERATIONAL:
      return getAvailableServices(
        PRODUCT_NAME.SECURITY,
        companyDetails.services,
      );
    case PAGE_NAME.TRANSPORT_OPERATIONAL:
      return getAvailableServices(
        PRODUCT_NAME.TRANSPORT,
        companyDetails.services,
      );
    case PAGE_NAME.CLEANER_OPERATIONAL:
      return getAvailableServices(
        PRODUCT_NAME.CLEANING,
        companyDetails.services,
      );
    case PAGE_NAME.MAINTENANCE_OPERATIONAL:
      return getAvailableServices(
        PRODUCT_NAME.MAINTENANCE,
        companyDetails.services,
      );
    default:
      return true; /// rest will be by checkIfUserIsAllowedView
  }
};

/**
 * Check that the services in the company have the correct category.
 * @param {string} category - the category that the caller wants services for
 * @param {[]} services - the list of services in the company object
 * @returns {[]} the list of services that are in the company for a given category
 */
export const getAvailableServices = (category, services) => {
  if (!services || services.length < 1) return [];
  const filteredServices = services.find(item => {
    let contains = false;
    services_suite.forEach(i => {
      if (i.id === item && i.category === category) {
        contains = true;
      }
    });
    return contains;
  });
  return filteredServices;
};
/**
 * This function helps to route a supervisor based on subscribed service.It will match and route to the first service found
 * @param {Object} companyDetails // Security Company Details
 * @returns {String}  PAGE_NAME to route
 */
/* eslint-disable consistent-return */
export const routeTheUserBasedOnSubscribedServices = companyDetails => {
  if (getAvailableServices(PRODUCT_NAME.SECURITY, companyDetails.services)) {
    return PAGE_NAME.SECURITY_OPERATIONAL;
  } else if (
    getAvailableServices(PRODUCT_NAME.CLEANING, companyDetails.services)
  ) {
    return PAGE_NAME.CLEANER_OPERATIONAL;
  } else if (
    getAvailableServices(PRODUCT_NAME.TRANSPORT, companyDetails.services)
  ) {
    return PAGE_NAME.TRANSPORT_OPERATIONAL;
  } else if (
    getAvailableServices(PRODUCT_NAME.MAINTENANCE, companyDetails.services)
  ) {
    return PAGE_NAME.MAINTENANCE_OPERATIONAL;
  }
};
/**
 * Compares the roles of a user with a list of roles
 * @param {[]} userRoles list of roles belonging to a user
 * @param {[]} requiredRoles a list of roles that you are checking for
 * @returns {boolean} true if there is some role in both lists or roles is empty/undefined
 */
export const userHasRole = ({ userRoles, requiredRoles }) => {
  if (isEmpty(userRoles)) return false;
  if (isEmpty(requiredRoles)) return true;
  const hasRole = userRoles.some(s => requiredRoles.includes(s));
  return hasRole;
};
export const SupervisorAndAbove = [
  ROLES.SUPERVISOR.id,
  ROLES.MANAGER.id,
  ROLES.SECURITY_COMPANY_MANAGER.id,
];
export const ManagerAndAbove = [
  ROLES.MANAGER.id,
  ROLES.SECURITY_COMPANY_MANAGER.id,
];
export const AccountHolderAndAbove = [ROLES.SECURITY_COMPANY_MANAGER.id];
export const AdminAndAbove = [ROLES.SRM_ADMIN.id];
